import React, { useState } from 'react';
import { Button, Input, Card } from '../components/ui';
import { authApi, setToken } from '../api/client';
import type { User } from '../api/types';

interface Props {
  onLogin: (user: User, token: string) => void;
  onGoRegister: () => void;
}

export const LoginPage: React.FC<Props> = ({ onLogin, onGoRegister }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await authApi.login(email, password);
      if (res.ok) {
        setToken(res.data.token);
        onLogin(res.data.user, res.data.token);
      } else {
        setError(res.error.message);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--bg-secondary)',
      }}
    >
      <div style={{ width: '100%', maxWidth: 400, padding: '0 16px' }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div
            style={{
              width: 48,
              height: 48,
              borderRadius: 12,
              background: 'var(--primary)',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontWeight: 800,
              fontSize: 20,
              marginBottom: 12,
            }}
          >
            BLS
          </div>
          <h1 style={{ fontSize: 22, fontWeight: 700 }}>Welcome back</h1>
          <p style={{ color: 'var(--text-secondary)', marginTop: 4 }}>
            Sign in to better_local_slock
          </p>
        </div>

        <Card>
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <Input
              label="Email"
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              required
            />
            <Input
              label="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
            {error && (
              <div
                style={{
                  background: '#FEE2E2',
                  color: '#991B1B',
                  padding: '8px 12px',
                  borderRadius: 'var(--radius)',
                  fontSize: 13,
                }}
              >
                {error}
              </div>
            )}
            <Button type="submit" disabled={loading} style={{ width: '100%', justifyContent: 'center' }}>
              {loading ? 'Signing in…' : 'Sign in'}
            </Button>
          </form>
        </Card>

        <p style={{ textAlign: 'center', marginTop: 16, fontSize: 13, color: 'var(--text-secondary)' }}>
          No account?{' '}
          <button
            onClick={onGoRegister}
            style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--primary)', fontWeight: 600 }}
          >
            Create one
          </button>
        </p>
      </div>
    </div>
  );
};
